var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    hasTarget,
    target,
    property
  } = options;

__p+='\n\n<div class="modal fade share-unavailable-modal" id="shareUnavailable" tabindex="-1" role="dialog">\n  <div class="modal-dialog modal-sm">\n    <div class="modal-content">\n      <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal" aria-label="Close">\n          <span class="modal-x-icon hidden-xs hidden-xxs" aria-hidden="true">&times;</span>\n          <span class="hidden-lg hidden-md hidden-sm" aria-hidden="true"><i class="ra ra-angle-left"></i></span>\n        </button>\n        <h2 class="modal-title">Something went wrong...</h2>\n      </div>\n      <div class="modal-body">\n        ';
 if (hasTarget) { 
__p+='\n          <p class="font-semibold">Sorry for the inconvenience.<br>Let&apos;s try again.</p>\n          <a href="#" data-toggle="modal" data-target="'+
((__t=( target ))==null?'':__t)+
'" data-property="'+
((__t=( property ))==null?'':__t)+
'" class="btn btn-primary">Try it again</a>\n        ';
 } else { 
__p+='\n          <p class="font-semibold">Sorry for the inconvenience.<br>Please try again later.</p>\n          <a href="#" data-dismiss="modal" class="btn btn-default">Close modal</a>\n        ';
 } 
__p+='\n      </div>\n    </div>\n  </div>\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/modal_error.jst.ejs